import React from 'react';
import type { ReactNode } from 'react';

import { expVal } from '@confluence/feature-experiments';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';
import { isRovoSystemSpaceKey } from '@confluence/route-manager/entry-points/isRovoSystemSpaceKey.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { SpaceOverview } from './SpaceOverview.tsx';
import { SmartSpaceOverview } from './smart-space-overview/SmartSpaceOverview.tsx';

type SpaceOverviewSwitcherProps = {
	spaceKey: string;
	children?: ReactNode;
};

export const SpaceOverviewSwitcher = ({ spaceKey, children }: SpaceOverviewSwitcherProps) => {
	const { isRovoEnabled } = useSessionData();

	const isSmartSpaceOverviewEnabled =
		!isCompanyHubSpaceKey(spaceKey) &&
		!isRovoSystemSpaceKey(spaceKey) &&
		isRovoEnabled &&
		expVal('smart_space_overview', 'isEnabled', false);

	if (isSmartSpaceOverviewEnabled) {
		return <SmartSpaceOverview spaceKey={spaceKey} />;
	}

	return <SpaceOverview spaceKey={spaceKey}>{children}</SpaceOverview>;
};
